import { Input } from "antd";
import { useState } from "react";

type TextareaInputProps = {
	disabled?: boolean;
	initialValue?: string;
	onChange: (value: string) => void;
	questionText?: string;
	hasError?: boolean;
	addDefaultValue?: string;
	onAddDefault?: () => void;
};

const TextareaInput = ({
	disabled = false,
	initialValue = "",
	onChange,
	hasError = false,
	addDefaultValue,
	onAddDefault
}: TextareaInputProps) => {
	const hasDefault = addDefaultValue != null && onAddDefault != null;
	const [value, setValue] = useState(hasDefault ? "" : initialValue);

	const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
		const trimmedValue = e.target.value.trim();
		setValue(trimmedValue);
		onChange(trimmedValue);
	};

	const handleAddDefault = () => {
		if (addDefaultValue != null && onAddDefault != null) {
			setValue(addDefaultValue);
			onAddDefault();
		}
	};

	return (
		<div className="flex flex-col gap-2">
			<Input.TextArea
				disabled={disabled}
				placeholder="Type here..."
				value={value}
				onChange={(e) => setValue(e.target.value)}
				onBlur={handleBlur}
				autoSize={{ minRows: 3, maxRows: 6 }}
				className={hasError ? "edc-input-error" : ""}
			/>
			{hasDefault && (
				<span
					role="button"
					tabIndex={0}
					onClick={(e) => {
						e.preventDefault();
						handleAddDefault();
					}}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							e.preventDefault();
							handleAddDefault();
						}
					}}
					className="cursor-pointer text-indigo-600 hover:text-indigo-700 w-fit">
					Add default
				</span>
			)}
		</div>
	);
};

export default TextareaInput;

